import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { useObserver } from 'mobx-react-lite';

import { msal } from '@config/msalConfig';
import { Header, RoleRestriction } from '@modules/core/components';
import { PreviousLocationProvider } from '@modules/core/providers';
import { Toaster } from '@modules/shared/components';
import { useStore } from '@store/StoreEffect';
import { HttpClient } from '@modules/core/utils';
import { PreviousLocationDiscarded, PreviousLocationDepth } from '@modules/shared/constants';
import { ProductPage } from '@pages/product-page/ProductPage';
import { EmptyProductsPage } from '@pages/product-page/EmptyProductsPage/EmptyProductsPage';

import './assets/styles/index.scss';

function App() {
    const { userStore, productsStoreAll } = useStore();

    const [loaded, setLoaded] = useState<boolean>();

    useEffect(() => {
        const initialize = async () => {
            const accounts = await msal.instance.getAllAccounts();
            if (accounts.length) {
                await msal.instance.setActiveAccount(accounts[0]);
            }
            const isFromInvite = window.location.search.includes('fromInvite');
            HttpClient.init();
            userStore.loadCurrentUser(isFromInvite);
            userStore.loadUserRoles();
            document.body.classList.add('theme-light');
            setLoaded(true);
        };
        initialize();
    }, [userStore]);

    return useObserver(() => {
        if (!loaded) {
            return null;
        }

        return (
            <RoleRestriction accessRoles={[]}>
                <main>
                    <Router>
                        <PreviousLocationProvider
                            depth={PreviousLocationDepth}
                            discardLocations={PreviousLocationDiscarded}
                        >
                            <header>
                                <Header user={userStore.currentUser} isSuperUser={userStore?.isSuperUser} />
                            </header>
                            <Toaster toasterId="global" />
                            <Switch>
                                <Route path="/">
                                    <section>
                                        {userStore.currentUser?.isMsalData ? (
                                            <EmptyProductsPage />
                                        ) : (
                                            <ProductPage productsStore={productsStoreAll} userStore={userStore} />
                                        )}
                                    </section>
                                </Route>
                            </Switch>
                        </PreviousLocationProvider>
                    </Router>
                </main>
            </RoleRestriction>
        );
    });
}

export default App;
